"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var cell_1 = require("./cell");

var row_actions_1 = require("./row-actions");

var isRoundedStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  & ", ":first-child {\n    border-radius: ", " 0\n      0 ", ";\n  }\n\n  & ", ":last-child {\n    border-radius: 0 ", "\n      ", " 0;\n  }\n"], ["\n  & ", ":first-child {\n    border-radius: ", " 0\n      0 ", ";\n  }\n\n  & ", ":last-child {\n    border-radius: 0 ", "\n      ", " 0;\n  }\n"])), cell_1.Cell, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.LARGE', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.LARGE', theme);
}, cell_1.Cell, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.LARGE', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.LARGE', theme);
});
var isAlternatingStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  &:nth-child(odd) ", " {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n  &:nth-child(odd) ", " {\n    background-color: ", ";\n  }\n"])), isRoundedStyles, cell_1.Cell, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["100"]', theme);
});
var hasHighlightsStyles = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  & ", " {\n    transition: ", ";\n  }\n\n  &:hover ", " {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n\n  & ", " {\n    transition: ", ";\n  }\n\n  &:hover ", " {\n    background-color: ", ";\n  }\n"])), isRoundedStyles, cell_1.Cell, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('MOTION.DEFAULT_TRANSITION', theme);
}, cell_1.Cell, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["100"]', theme);
});
exports.Row = styled_components_1.default.tr(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  ", "\n\n  @media (any-hover: hover) {\n    ", " {\n      opacity: 0;\n      pointer-events: none;\n    }\n    &:hover ", ", &:focus-within ", " {\n      opacity: 1;\n      pointer-events: all;\n    }\n  }\n"], ["\n  ", "\n\n  ", "\n\n  @media (any-hover: hover) {\n    ", " {\n      opacity: 0;\n      pointer-events: none;\n    }\n    &:hover ", ", &:focus-within ", " {\n      opacity: 1;\n      pointer-events: all;\n    }\n  }\n"])), function (_a) {
  var isHeading = _a.isHeading,
      isAlternating = _a.isAlternating;
  return !isHeading && isAlternating && isAlternatingStyles;
}, function (_a) {
  var isHeading = _a.isHeading,
      hasHighlights = _a.hasHighlights;
  return !isHeading && hasHighlights && hasHighlightsStyles;
}, row_actions_1.RowActions, row_actions_1.RowActions, row_actions_1.RowActions);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;